import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SvgLogo } from '@actual-app/components/icons/logo';
import { styles } from '@actual-app/components/styles';
import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import { Link } from '#components/common/Link';
import { Modal, ModalCloseButton, ModalHeader } from '#components/common/Modal';
import { useServerVersion } from '#components/ServerContext';

export function AboutModal() {
  const { t } = useTranslation();
  const serverVersion = useServerVersion();

  const details = [
    { label: t('App version'), value: `v${window.Actual.ACTUAL_VERSION}` },
    { label: t('Server version'), value: serverVersion },
  ];

  return (
    <Modal name="about" containerProps={{ style: { width: 400 } }}>
      {({ state }) => (
        <>
          <ModalHeader
            title={t('About Pesa Wise')}
            rightContent={<ModalCloseButton onPress={() => state.close()} />}
          />
          <View style={{ alignItems: 'center', gap: 10, paddingBottom: 10 }}>
            <SvgLogo
              width={40}
              height={40}
              style={{ color: theme.pageTextPositive }}
            />
            <Text style={{ ...styles.mediumText, fontWeight: 700 }}>
              Pesa Wise
            </Text>
            <Text
              style={{
                color: theme.pageTextLight,
                textAlign: 'center',
                fontStyle: 'italic',
              }}
            >
              <Trans>Your finances - made simple</Trans>
            </Text>
          </View>
          <View style={{ marginTop: 10 }}>
            {details.map(({ label, value }) => (
              <View
                key={label}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  padding: '7px 0',
                  borderBottom: `1px solid ${theme.tableBorder}`,
                }}
              >
                <Text style={{ color: theme.pageTextLight }}>{label}</Text>
                <Text style={{ fontWeight: 600 }}>{value}</Text>
              </View>
            ))}
          </View>
          <Text
            style={{
              marginTop: 15,
              color: theme.pageTextLight,
              fontSize: 13,
              textAlign: 'center',
            }}
          >
            <Trans>
              Built on the MIT-licensed{' '}
              <Link
                variant="external"
                to="https://actualbudget.org"
                linkColor="muted"
              >
                Actual Budget
              </Link>{' '}
              project.
            </Trans>
          </Text>
        </>
      )}
    </Modal>
  );
}
